import { useContext } from "react";

import WordContext from "./WordContext";
import WordList from './WordList';
import "./Footer.css";

const Footer = () => {
	const {
		verbs, addVerb, removeVerb,
		nouns, addNoun, removeNoun,
		adjectives, addAdjective, removeAdjective,
		reasons, addReason, removeReason,
	} = useContext(WordContext);

	return (
		<footer className="footer">
        <div className="footer-list-editors">
          <WordList
            placeholder="Add Verb"
            list={verbs}
            addToList={addVerb}
            removeFromList={removeVerb}
          />
          <WordList
            placeholder="Add Noun"
            list={nouns}
            addToList={addNoun}
            removeFromList={removeNoun}
          />
          <WordList
            placeholder="Add Adjective"
            list={adjectives}
            addToList={addAdjective}
            removeFromList={removeAdjective}
          />
          <WordList
            placeholder="Add Reason"
            list={reasons}
            addToList={addReason}
            removeFromList={removeReason}
          />
        </div>
      </footer>
	);
};

export default Footer;
